/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, NgModule, LOCALE_ID } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

registerLocaleData(localeEs);
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbThemeModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { AuthInterceptor } from './auth.interceptor';
import { HttpserviceService } from './services/httpservice.service';
import { Observable } from 'rxjs';

import { NbAuthJWTToken, NbAuthModule, NbPasswordAuthStrategy } from '@nebular/auth';




@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbThemeModule.forRoot({ name: 'default' }),

    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    NbAuthModule.forRoot({
      strategies: [

/*
ng build  \
         --base-href ./ \
         --deploy-url ./
*/


        NbPasswordAuthStrategy.setup({
        name: 'email',
         baseEndpoint: '/ware/auth',  // Cambia a tu URL de API backend
         //baseEndpoint: 'http://localhost/ware/auth', 
          login: { 
            endpoint: '/index.php?endpoint=login',
            method: 'post',
            redirect: {
              success: null, // La redirección se resuelve dinámicamente por perfil en el componente de login
              failure: null,               // Puedes poner una ruta para fallos de autenticación
            },
          },
          token: {
            class: NbAuthJWTToken,
            key: 'token', // Se extrae el token desde el campo "token"
          },
          register: {
            endpoint: '/index.php?endpoint=register',
            method: 'post',
          },
          logout: {
            endpoint: '/index.php?endpoint=logout',
            method: 'post',
          },
          requestPass: {
            endpoint: '/index.php?endpoint=request-password',
            method: 'post',
          },
          resetPass: {
            endpoint: '/index.php?endpoint=reset-pass',
            method: 'post',
          },
          
        }),
      ],
      forms: {
        login: {
          redirectDelay: 500,
          rememberMe: false,
          showMessages: {
            success: true,
          },
          // Traducciones en español
          socialLinks: [], // Opcional: elimina las redes sociales
          submitButton: 'Iniciar sesión',
          validation: {
            email: {
              required: 'El email es obligatorio',
              pattern: 'Por favor introduce un email válido',
            },
            password: {
              required: 'La contraseña es obligatoria',
              minLength: 'La contraseña debe tener al menos 6 caracteres',
              maxLength: 'La contraseña no puede tener más de 50 caracteres',
            },
          },
          placeholders: {
            email: 'Introduce tu email',
            password: 'Introduce tu contraseña',
          },
          messages: {
            success: 'Inicio de sesión exitoso',
            error: 'El email o la contraseña son incorrectos',
          },
        },
        register: {
          formTitle: 'Crear cuenta',
          buttonText: 'Registrar',
          terms: false,
          validation: {
            password: {
              required: 'Contraseña es obligatoria',
              minLength: 'La contraseña debe tener al menos {{ minLength }} caracteres',
              maxLength: 'La contraseña no debe exceder {{ maxLength }} caracteres',
            },
            email: {
              required: 'Correo electrónico es obligatorio',
              pattern: 'Ingrese un correo electrónico válido',
            },
            fullName: {
              required: 'Nombre completo es obligatorio',
            },
          },
        },
        requestPassword: {
          formTitle: 'Recuperar contraseña',
          buttonText: 'Enviar enlace de recuperación',
        },
        resetPassword: {
          formTitle: 'Restablecer contraseña',
          buttonText: 'Restablecer',
        },
        logout: {
          buttonText: 'Cerrar sesión',
        },
      },
    }),
  ],

  bootstrap: [AppComponent],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'es-ES' },
  ],
})
export class AppModule {
}
